const GET_DISPOSITION_PENALTY_FEE = 'GET_DISPOSITION_PENALTY_FEE';
const SET_DISPOSITION_PENALTY_FEE = 'SET_DISPOSITION_PENALTY_FEE';
const GET_PENALTY_GLOBAL_FLAG = 'GET_PENALTY_GLOBAL_FLAG';
const SET_PENALTY_GLOBAL_FLAG = 'SET_PENALTY_GLOBAL_FLAG';

const GET_DISPOSITION_PENALTY_FEE_GRID_DATA = 'GET_DISPOSITION_PENALTY_FEE_GRID_DATA'
const SET_DISPOSITION_PENALTY_FEE_GRID_DATA = 'SET_DISPOSITION_PENALTY_FEE_GRID_DATA'

const GET_DISPOSITION_EQUIPMENT_CLASS = 'GET_DISPOSITION_EQUIPMENT_CLASS'
const SET_DISPOSITION_EQUIPMENT_CLASS = 'SET_DISPOSITION_EQUIPMENT_CLASS'

const GET_DISPOSITION_TYPE = 'GET_DISPOSITION_TYPE'
const SET_DISPOSITION_TYPE = 'SET_DISPOSITION_TYPE'

export {
    GET_DISPOSITION_PENALTY_FEE,
    SET_DISPOSITION_PENALTY_FEE,
    GET_PENALTY_GLOBAL_FLAG,
    SET_PENALTY_GLOBAL_FLAG,
    GET_DISPOSITION_PENALTY_FEE_GRID_DATA,
    SET_DISPOSITION_PENALTY_FEE_GRID_DATA,
    GET_DISPOSITION_EQUIPMENT_CLASS,
    SET_DISPOSITION_EQUIPMENT_CLASS,
    GET_DISPOSITION_TYPE,
    SET_DISPOSITION_TYPE
};
